import { render, staticRenderFns } from "./whatnowInstruction.vue?vue&type=template&id=399296b0&scoped=true"
import script from "./whatnowInstruction.vue?vue&type=script&lang=js"
export * from "./whatnowInstruction.vue?vue&type=script&lang=js"
import style0 from "./whatnowInstruction.vue?vue&type=style&index=0&id=399296b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399296b0",
  null
  
)

export default component.exports